<div class="wrapper">
  <mat-card class="content">
    <mat-card-content>
      @if (type() == Role.Driver || type() == Role.CoDriver) {
        <mat-list role="list">
          <h2 class="list-title">
            Klik op een dagdeel waarvoor jij bent ingepland om de details van je rit(ten) te zien.
          </h2>
          @for (driverDaypart of driverDayparts(); track driverDaypart.id) {
            <mat-list-item
              [routerLink]="['/planning', type(), 'daypart', driverDaypart.id]"
              [queryParams]="{ userId: userId }"
              class="ride-item"
            >
              <div class="startTime">
                <div class="driver-planned-dayparts">
                  <div
                    class="planned-rides-driver"
                    [ngStyle]="{
                      'border-left-color': driverDaypart.vehicle?.calendarStyle?.color || 'transparent',
                    }"
                  >
                    <div class="flex-wrapper">
                      <b>Datum:&nbsp;</b>
                      {{ ucFirst((driverDaypart.date | date: 'fullDate') ?? '') }}
                    </div>
                    <div class="flex-wrapper">
                      <p>
                        <b>Van:</b>
                        {{ driverDaypart.startHour }}:{{ driverDaypart.startMin }}
                      </p>
                      <p>
                        &nbsp;tot
                        {{ driverDaypart.endHour }}:{{ driverDaypart.endMin }}
                      </p>
                    </div>
                    <div class="flex-wrapper">
                      @if (driverDaypart.vehicle) {
                        <p><b>Voertuig:</b> {{ driverDaypart.vehicle.name }}</p>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </mat-list-item>
          }
          @if (driverDayparts().length === 0 && loading() === false) {
            <p class="no-items">Je bent nog nergens voor ingepland</p>
          }
        </mat-list>
      }

      @if (type() == Role.Planner) {
        <mat-list class="planner-list" role="list">
          @for (plannerDayPart of plannerDayparts(); track plannerDayPart.id) {
            <mat-list-item class="ride-item">
              <div class="startTime">
                <div class="driver-planned-dayparts">
                  <div class="planned-rides-driver">
                    <div class="flex-wrapper">
                      <b>Datum: </b>
                      {{ ucFirst((plannerDayPart.date | date: 'fullDate') ?? '') }}
                    </div>
                    <div class="flex-wrapper">
                      <p>
                        <b>Van:</b>
                        {{ plannerDayPart.startHour }}:{{ plannerDayPart.startMin }}
                      </p>
                      <p>
                        &nbsp;tot:
                        {{ plannerDayPart.endHour }}:{{ plannerDayPart.endMin }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </mat-list-item>
          }
          @if (plannerDayparts().length === 0 && loading() === false) {
            <p class="no-items">Je bent nog nergens voor ingepland</p>
          }
        </mat-list>
      }
    </mat-card-content>
  </mat-card>
</div>
